<template>
  <div class="radio-option" :class="classes" @click="select()">
    <label v-text="label"></label>
  </div>
</template>

<script>
import { REGISTRATION_UPDATE } from "../../store/types";
import { mapGetters } from "vuex";

export default {
  inject: ["attribute"],

  props: {
    label: {
      required: false,
    },
    value: {
      required: false,
    },
  },

  computed: {
    ...mapGetters(["getRegistrationValue"]),

    classes() {
      return {
        selected: this.getRegistrationValue(this.attribute) === this.computed_value,
      };
    },

    computed_value() {
      return this.value !== undefined ? this.value : this.label;
    },
  },

  methods: {
    select() {
      if (this.getRegistrationValue(this.attribute) === this.computed_value) {
        return;
      }

      const payload = {
        [this.attribute]: this.computed_value,
      };

      this.$store.commit(REGISTRATION_UPDATE, { payload });
    },
  },
};
</script>
